import { useTranslation } from 'next-i18next';

import React from 'react';

import { Box, Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';

import { IconProps, IconsLinear } from '@nocowanie/icons';

import { CheckoutConfirmationInfoProps } from '@app/components/molecules/checkout-confirmation-info';

export const CheckoutConfirmationInfo = ({
    withPrepayment,
    isSummary = false,
    ...rest
}: CheckoutConfirmationInfoProps) => {
    const { t } = useTranslation('checkout');
    const responsiveStyles = useBreakpointValue({
        base: {
            iconSize: 'sm' as IconProps['size'],
            boxStyles: {
                p: 3,
            },
        },
        md: {
            iconSize: 'md' as IconProps['size'],
            boxStyles: {
                p: 5,
            },
        },
    });

    return (
        <Flex
            alignItems="flex-start"
            gap={3}
            border={'1px solid {colors.border}'}
            borderRadius={'md'}
            {...responsiveStyles?.boxStyles}
            {...rest}
        >
            <IconsLinear.Timer1 size={responsiveStyles?.iconSize} />
            <Box flexGrow={1}>
                <Heading as={'h3'} size={'xs'} mb={2}>
                    {t('confirmationInfo.header')}
                </Heading>
                <Text
                    fontSize={{
                        base: 'sm',
                        md: 'md',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: isSummary
                            ? t(
                                  withPrepayment
                                      ? 'summary.confirmationWarningWithPrepayment'
                                      : 'summary.confirmationWarning',
                              )
                            : t(
                                  withPrepayment
                                      ? 'confirmationInfo.prepaymentText'
                                      : 'confirmationInfo.text',
                              ),
                    }}
                />
            </Box>
        </Flex>
    );
};
